import { ROLE_ICONS } from "@/lib/roles";

export function RoleBadge({ role, size = "sm" }) {
  if (!role) return null;
  const Icon = ROLE_ICONS[role.icon] || ROLE_ICONS.crown;
  const sz = size === "xs" ? "text-[9px] px-1.5 py-0.5 gap-1" : size === "lg" ? "text-xs px-3 py-1 gap-2" : "text-[10px] px-2 py-0.5 gap-1.5";
  const c = role.color || "#00F0FF";
  return (
    <span
      data-testid="role-badge"
      className={`inline-flex items-center rounded-md border font-mono-cx font-semibold uppercase tracking-wider ${sz}`}
      style={{ color: c, borderColor: `${c}99`, backgroundColor: `${c}1f`, textShadow: `0 0 12px ${c}66` }}
    >
      <Icon className={size === "lg" ? "h-3.5 w-3.5" : "h-3 w-3"} /> {role.label}
    </span>
  );
}
